import { useMediaQuery } from "usehooks-ts";
import { Button, Container, Flex, Grid, Stack } from "@mantine/core";
import Link from "next/link";

function TextImageHero(props) {
  const isMobile = useMediaQuery("(max-width: 1024px)");

  // styles
  const titleStyle = {
    fontWeight: "bolder",
    fontSize: "64px",
    textTransform: "uppercase",
    textAlign: isMobile ? "center" : "initial",
    color: props.color,
  };
  const buttonTextStyle = { fontWeight: "bolder", textTransform: "uppercase" };
  const valueTextStyle = {
    fontWeight: "bolder",
    fontSize: isMobile ? "30px" : "42px",
    color: props.color,
    textAlign: isMobile ? "center" : "initial",
  };
  const labelTextStyle = {
    textAlign: isMobile ? "center" : "initial",
  };

  // components
  const textJSX = () => (
    <Stack align={isMobile ? "center" : "flex-start"}>
      <div style={titleStyle}>{props.title}</div>
      {props.showButton && (
        <Link href={props.buttonUrl}>
          <Button size="xl" radius="xl" bg={props.color} mb={40}>
            <div style={buttonTextStyle}>{props.buttonTitle}</div>
          </Button>
        </Link>
      )}
      <Grid w={isMobile ? "80%" : "100%"} gutter={"lg"}>
        {props.data.map((item, index) => (
          <Grid.Col key={index} span={4}>
            <Stack spacing={0}>
              <div style={valueTextStyle}>{item.valueText}</div>
              <div style={labelTextStyle}>{item.labelText}</div>
            </Stack>
          </Grid.Col>
        ))}
      </Grid>
    </Stack>
  );
  const imageJSX = () => (
    <img style={{ maxWidth: "100%" }} src={props.imgSrc} />
  );

  const contentJSX =
    props.isImageLeft && !isMobile ? (
      <>
        {imageJSX()}
        {textJSX()}
      </>
    ) : (
      <>
        {textJSX()}
        {imageJSX()}
      </>
    );

  const layoutJSX = isMobile ? (
    <Stack align={"center"}>{contentJSX}</Stack>
  ) : (
    <Flex justify={"center"} align={"center"} gap={40}>
      {contentJSX}
    </Flex>
  );

  return (
    <Container p={{ base: 24, md: 48 }} miw={"100%"}>
      {layoutJSX}
    </Container>
  );
}

export default TextImageHero;
